<template>
  <div>
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <div style="width: 35%">
          <v-text-field
            v-model="cashierSearch"
            :label="$t('general.search')"
            clearable
            prepend-inner-icon="search">
          </v-text-field>
        </div>
        <v-dialog
          persistent
          v-model="dialog"
          max-width="700px">
          <template v-slot:activator="{ on }">
            <v-btn
              class="mt-3 mx-3"
              color="primary"
              round
              dark
              v-on="on">
              <v-icon left>person_add</v-icon>
              {{ $t('cashier.addCashier') }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">{{$t('cashier.addCashier')}}</h2>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-xs>
                <v-form
                  lazy-validation
                  ref="form">
                  <v-autocomplete
                    v-model="editedItem.user_id"
                    prepend-icon="person"
                    :error-messages="errors.name"
                    :rules="rules.required"
                    :items="filterUsers"
                    item-text="name"
                    item-value="id"
                    :label="$t('cashier.selectionUserCashier')">
                  </v-autocomplete>
                  <v-autocomplete
                    clearable
                    v-model="editedItem.area_id"
                    :items="filterAreas"
                    item-text="name"
                    item-value="id"
                    prepend-icon="group_work"
                    :label="$t('cashier.areaCashier')">
                  </v-autocomplete>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-1"
                round
                flat
                @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                color="primary"
                round
                depressed
                :loading="loading"
                :disabled="loading"
                @click="save">
                {{ $t('general.submit') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-data-table
        :search="cashierSearch"
        class="elevation-2"
        :headers="headers"
        :items="cashiers"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination">

        <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['font-weight-black white--text column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{header.text}}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td class="text-sm-center">{{props.item.user && props.item.user.name}}</td>
          <td class="text-sm-center">{{props.item.area !== null ? props.item.area.name : null}}</td>
          <td class="text-sm-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                small
                outline
                icon
                color="error"
                v-on="on"
                @click="removed(props.item)">
                <v-icon small>delete</v-icon>
              </v-btn>
              </template>
              <span>{{ $t('general.delete')  }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      </v-data-table>
      <v-dialog persistent v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="error--text font-weight-bold mb-0">{{ $t('cashier.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">
              {{ $t('cashier.name')}}: </span>{{removedItem.user.name}}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="closeDelete">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="error"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="deleteItem(removedItem)">
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'cashierComponent',
  data () {
    return {
      cashierSearch: '',
      removeDialog: false,
      loading: false,
      loadingItems: true,
      dialog: false,
      users: [],
      areas: [],
      cashiers: [],
      errors: {},
      editedItem: {
        user_id: null,
        area_id: null
      },
      defaultItem: {
        user_id: null,
        area_id: null
      },
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      removedItem: {
        user: {
          name: ''
        },
        area: {
          name: ''
        }
      },
      userLogged: {
        roles: [
          {
            id: null
          }
        ],
        company: [
          {
            id: null
          }
        ]
      }
    }
  },
  computed: {
    heading () {
      return this.$t('cashier.name')
    },
    subheading () { return '' },
    icon () {
      return 'fas fa-wallet fa-fw icon-color'
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: this.$t('cashier.name'),
          align: 'center',
          value: 'user.name',
          sortable: true
        },
        {
          text: this.$t('area.name'),
          align: 'center',
          value: 'area.name',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    },
    filterAreas () {
      if (this.userLogged.roles && this.userLogged.roles[0].id === 2) {
        return this.areas.filter(item => item.company_id === this.userLogged.company[0].id)
      }
    },
    filterUsers () {
      return this.users.filter(item => item.company.length !== 0 && item.company[0].id === this.userLogged.company[0].id)
    }
  },
  watch: {
    '$store.state.userLogged' () {
      this.getLogged()
    },
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.getLogged()
    this.get()
    this.getCashier()
  },
  methods: {
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    deleteItem (item) {
      this.loading = true
      const index = this.cashiers.indexOf(item)
      this.delete(item, index)
    },
    delete (item, index) {
      this.$emit('cashierDelete', {
        item: item,
        index: index,
        context: this
      })
    },
    close () {
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$refs.form.resetValidation()
      this.loading = false
      this.dialog = false
      this.errors = {}
    },
    closeDelete () {
      this.removeDialog = false
      this.loading = false
    },
    get () {
      this.$emit('usersGet', {context: this})
      this.$emit('areasGet', {context: this})
    },
    getCashier () {
      this.$emit('cashierGet', {context: this})
    },
    save () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.userLogged.roles[0].id === 2) {
          this.$emit('cashierPost', {
            item: this.editedItem,
            context: this
          })
        }
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/cashier.component.vue